__turbopack_context__.v({
  "badge": "PGccLa_badge",
  "badgesWrapper": "PGccLa_badgesWrapper",
  "row": "PGccLa_row",
  "sliderDot": "PGccLa_sliderDot",
  "sliderDots": "PGccLa_sliderDots",
  "title": "PGccLa_title",
});
